import { ReactNode } from 'react';

import { CaseObject } from 'dashboard/models/case';

interface LayoutListProps {
  resources: CaseObject[];
  displayItem: (data: CaseObject, index: number) => ReactNode;
}

const LayoutList = ({ resources, displayItem }: LayoutListProps) => {
  return <>{resources.map((resource, i) => displayItem(resource, i))}</>;
};

export default LayoutList;
